<template lang="pug">
md-layout(md-column='', md-align='start')
  md-theme(md-name='brown-white')
    // Title
    breadcrumbs(section='Reporting', :nav='nav')

  md-theme(md-name='blue')
    // Reports List
    domains-table
</template>

<script>
  import { mapState } from 'vuex';
  import DomainsTable from '../../shared-components/report/DomainsTable';
  import Breadcrumbs from '../../shared-components/Breadcrumbs';

  export default {
    components: {
      DomainsTable,
      Breadcrumbs
    },
    computed: {
      ...mapState({
        useraccount: state => state.user.useraccount,
        siteuser: state => state.user.siteuser
      }),
      nav() {
        return [
          { title: 'Domains'}
        ]
      }

    }
  };
</script>

<style lang="scss">
  .on-left {
    margin-top: -5px;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/spa/reporting/Domains.vue